import { useWebsiteBanner, WEBSITE_BANNER_PRIORITY } from '@shared/components/WebsiteBanner';
import { useTranslation } from '@shared/core';

interface UseChangesReminderBannerArgs
  extends Readonly<{
    eventHandle: string;
    isVisible: boolean;
    onClickLink: () => void;
    onClose?: () => void;
  }> {}

/**
 * Registers the changes reminder banner.
 * Shows when there are unpublished changes to the website.
 */
export const useChangesReminderBanner = (args: UseChangesReminderBannerArgs) => {
  const { isVisible, onClose } = args;
  const { tq } = useTranslation('publishReminder');

  useWebsiteBanner({
    id: 'changes-reminder',
    priority: WEBSITE_BANNER_PRIORITY.changesReminder,
    isVisible,
    message: {
      default: tq`Not seeing your design changes? Check that you've applied changes in the design page`,
    },
    onClose,
  });
};
